var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stake-section"},[_c('div',{staticClass:"stake-section-background",style:({ backgroundImage: `url(${_vm.stakeImage})` })},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stake-section-text"},[_c('div',{staticClass:"text-line"},[_vm._v("High-stakes casino action meets")]),_c('div',{staticClass:"text-line"},[_vm._v("FIFA-level football intensity.")])])
}]

export { render, staticRenderFns }